import { IconButton } from "@mui/material";
import React from "react";
import UpdateIcon from "./icon/UpdateIcon";

export default function UpdateBtn({ handleUpdate, ...props }) {
  return (
    <IconButton
      {...props}
      sx={{ width: "32px", height: "32px", background: "var(--grey) !important", color: props.disabled ? "#b0b0b0" : "#000" }}
      onClick={handleUpdate}
    >
      <UpdateIcon />
    </IconButton>
  );
}
